import React, { useState } from "react";

//MUI
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// Icons
import RouteAddIcon from "@/icons/RouteAddIcon";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { Collapse, Typography } from "@mui/material";

type ObilaznicePointItemsType =
  {
    items: DCRecord[],
    onClick: (evt: React.MouseEvent<HTMLDivElement>, item: DCRecord) => void
    onAddToRoute: (evt: React.MouseEvent<HTMLButtonElement>, item: DCRecord) => void
    canAddToRoute?: boolean,
    selectedId?: number,
    itemIcon?: React.ReactElement,
    primaryTextFn: (item: DCRecord) => string | null,
    secondaryTextFn: (item: DCRecord) => string | null,
    grouped?: boolean,
    groupName?: string
  }

function ObilaznicePointItems(props: ObilaznicePointItemsType) {
  const { items, selectedId, onClick, onAddToRoute, itemIcon, canAddToRoute, primaryTextFn, secondaryTextFn, grouped, groupName } = props;

  const [open, setOpen] = React.useState(true);

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      {grouped ? 
      <>
        <ListItemButton onClick={handleOpen}>
          <ListItemText primary={groupName} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {Array.isArray(items) ? items.map((item, i) => {
              const selected = selectedId === item["point_id"] as number;

              const primaryText = primaryTextFn(item);
              const secondaryText = secondaryTextFn(item);

              return (
                <ListItem key={`item-${item["point_id"]}`}>
                  <ListItemButton dense disableGutters onClick={(evt) => onClick(evt, item)} selected={selected}>
                    <ListItemAvatar >
                      {itemIcon ? 
                      <Avatar sx={{ bgcolor: 'transparent' }}>
                        {itemIcon}
                      </Avatar>
                      : 
                      <Avatar sx={{ width: 30, height: 30, backgroundColor: 'transparent', border: theme => `2px solid ${theme.palette.primary.main}` }}>
                        <Typography color="primary">
                          {item["sortorder"] as number}
                        </Typography>
                      </Avatar>
                      }
                    </ListItemAvatar>
                    {
                      primaryText && primaryText !== null && secondaryText && secondaryText !== null && primaryText.toUpperCase() !== secondaryText.toUpperCase() ?
                        <ListItemText
                          primary={primaryText}
                          secondary={secondaryText} /> :
                        <ListItemText
                          primary={primaryText} />
                    }
                    {canAddToRoute && selected ? (
                      <ListItemSecondaryAction>
                        <IconButton aria-label="add-to-route" onClick={(evt) => onAddToRoute(evt, item)}><RouteAddIcon transform="scale(1.47)" /></IconButton>
                      </ListItemSecondaryAction>
                    ) : null}
                  </ListItemButton>
                </ListItem>
              );
            }) : null
            }
        </Collapse>
      </>
      : 
      <>
      {Array.isArray(items) ? items.map((item, i) => {

        const selected = selectedId === item["point_id"] as number;

        const primaryText = primaryTextFn(item);
        const secondaryText = secondaryTextFn(item);

        return (
          <ListItem key={`item-${item["point_id"]}`}>
            <ListItemButton dense disableGutters onClick={(evt) => onClick(evt, item)} selected={selected}>
              <ListItemAvatar >
                {itemIcon ? 
                <Avatar sx={{ bgcolor: 'transparent' }}>
                  {itemIcon}
                </Avatar>
                : 
                <Avatar sx={{ width: 30, height: 30, backgroundColor: 'transparent', border: theme => `2px solid ${theme.palette.primary.main}` }}>
                  <Typography color="primary">
                    {item["sortorder"] as number}
                  </Typography>
                </Avatar>
                }
              </ListItemAvatar>
              {
                primaryText && primaryText !== null && secondaryText && secondaryText !== null && primaryText.toUpperCase() !== secondaryText.toUpperCase() ?
                  <ListItemText
                    primary={primaryText}
                    secondary={secondaryText} /> :
                  <ListItemText
                    primary={primaryText} />
              }
              {canAddToRoute && selected ? (
                <ListItemSecondaryAction>
                  <IconButton aria-label="add-to-route" onClick={(evt) => onAddToRoute(evt, item)}><RouteAddIcon transform="scale(1.47)" /></IconButton>
                </ListItemSecondaryAction>
              ) : null}
            </ListItemButton>
          </ListItem>
        );
      }) : null
      }
      </>
    }
    </>);
}

export default ObilaznicePointItems;
